import { switchMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { CookieService } from '../../services/cookie-service';
import * as Cookies from '../../constants/cookies';
import * as Actions from './admin.actions';

export const dropinEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.DROPIN_START),
    switchMap((action) => {
      const now = new Date();
      const expireTime = now.setHours(now.getHours() + 2);
      CookieService.setCookieValueWithPathAndDomain(Cookies.Impersonation, action.seller);
      CookieService.setCookieValueWithPathAndDomain(Cookies.ImpersonationExpires, expireTime);
      window.location.reload();

      return EMPTY;
    }),
  );
};

export const endDropin = (action$) => {
  return action$.pipe(
    ofType(Actions.DROPIN_END),
    switchMap((action) => {
      CookieService.removeCookie(Cookies.Impersonation);
      CookieService.removeCookie(Cookies.ImpersonationExpires);

      if (action.reload) {
        window.location.reload();
      }

      return EMPTY;
    }),
  );
};
